import { srsPoints } from './mappings';

const MAX_LEVEL = 80;

export const RANK_TIERS = [
  { min: 1,  max: 10, kanji: '歩',    reading: 'Pawn',           cssVar: '--color-srs-0' },
  { min: 11, max: 20, kanji: '香',    reading: 'Lance',          cssVar: '--color-srs-1' },
  { min: 21, max: 30, kanji: '桂',    reading: 'Knight',         cssVar: '--color-srs-2' },
  { min: 31, max: 40, kanji: '銀',    reading: 'Silver General', cssVar: '--color-srs-3' },
  { min: 41, max: 50, kanji: '金',    reading: 'Gold General',   cssVar: '--color-srs-4' },
  { min: 51, max: 60, kanji: '角',    reading: 'Bishop',         cssVar: '--color-srs-5' },
  { min: 61, max: 70, kanji: '飛',    reading: 'Rook',           cssVar: '--color-srs-6' },
  { min: 71, max: 79, kanji: '王',    reading: 'King',            cssVar: '--color-srs-7' },
  { min: 80, max: 80, kanji: '聴き方', reading: 'Kikikata',       cssVar: '--color-srs-7' },
];

function getTier(level) {
  return RANK_TIERS.find((t) => level >= t.min && level <= t.max) || RANK_TIERS[0];
}

// threshold(n) = 800 * (n-1)² — points needed to reach level n
// Level 1 always starts at 0 pts. Level 2 = 800, Level 3 = 3,200, Level 80 = 4,992,800
function levelThreshold(n) {
  return 800 * (n - 1) * (n - 1);
}

export function computeRank(countsBySrs) {
  if (!countsBySrs || Object.keys(countsBySrs).length === 0) return null;

  const sentences = countsBySrs.sentences || {};
  const words = countsBySrs.words || {};

  let score = 0;
  for (let stage = 1; stage <= 7; stage++) {
    score += (sentences[stage] || 0) * srsPoints[stage];
    score += (words[stage] || 0) * srsPoints[stage];
  }
  // Skipped items count as Titanium (stage 7) — they are mastered but excluded from SRS
  score += (sentences['skipped'] || 0) * srsPoints[7];
  score += (words['skipped'] || 0) * srsPoints[7];

  // level = floor(√(score / 800)) + 1, clamped to [1, 80]
  const level = Math.min(MAX_LEVEL, Math.floor(Math.sqrt(score / 800)) + 1);
  const tier = getTier(level);

  const isMaxLevel = level === MAX_LEVEL;
  const currentThreshold = levelThreshold(level);
  const nextThreshold = isMaxLevel ? null : levelThreshold(level + 1);
  const rangeSize = nextThreshold ? nextThreshold - currentThreshold : 1;
  const progress = isMaxLevel ? 1 : Math.max(0, Math.min(1, (score - currentThreshold) / rangeSize));
  const pointsToNext = isMaxLevel ? 0 : nextThreshold - score;

  const nextLevel = isMaxLevel ? null : level + 1;
  const nextTier = nextLevel ? getTier(nextLevel) : null;
  const nextLabel = nextLevel ? `${nextLevel}${nextTier.kanji}` : null;

  // Max level gets the app's primary brand gradient instead of solid titanium
  const tierBg = isMaxLevel
    ? 'linear-gradient(135deg, var(--color-primary), var(--color-secondary))'
    : `var(${tier.cssVar})`;

  return {
    score,
    level,
    tier,
    tierBg,           // use this for backgrounds/borders — gradient at max level, solid otherwise
    label: `${level}${tier.kanji}`,       // e.g. "51翠"
    fullLabel: `${level}段 ${tier.kanji}`, // e.g. "51段 翠"
    progress,
    pointsToNext,
    currentThreshold,
    nextThreshold,
    nextLabel,
    isMaxLevel,
  };
}